import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServerError() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <div className="text-center">
            <div className="mb-4">
              <i className="fas fa-bug fa-5x text-danger"></i>
            </div>
            <h1 className="display-1 text-muted">500</h1>
            <h2 className="mb-4">{t('server_error.title')}</h2>
            <p className="lead text-muted mb-4">
              {t('server_error.description')}<br />
              {t('server_error.description_line2')}
            </p>
            <div className="mb-4">
              <Button variant="primary" className="me-2" onClick={() => navigate('/dashboard')}>
                <i className="fas fa-home me-2"></i>
                {t('server_error.back_to_dashboard')}
              </Button>
              <Button variant="outline-secondary" onClick={() => window.location.reload()}>
                <i className="fas fa-redo me-2"></i>
                {t('server_error.reload_page')}
              </Button>
            </div>
            <Card>
              <Card.Body>
                <h5>{t('server_error.if_problem_persists')}</h5>
                <p className="text-muted">
                  {t('server_error.if_problem_persists_text')}
                </p>
                <Row>
                  <Col md={6}>
                    <Link to="/contact" className="btn btn-outline-primary btn-sm w-100">
                      <i className="fas fa-envelope me-2"></i>
                      {t('server_error.contact')}
                    </Link>
                  </Col>
                  <Col md={6}>
                    <Link to="/help" className="btn btn-outline-secondary btn-sm w-100">
                      <i className="fas fa-question-circle me-2"></i>
                      {t('server_error.help')}
                    </Link>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

